/**
 * The menu button (slice 6b): a small ≡ in the top-right corner, a 44 px
 * target clear of the safe areas, in both scenes and on every device (the
 * corner tap of the pause menu), drawn as the kit's window (`.ab-window`);
 * its three bars are CSS, its label `ui.pad.menu`. One window at a time (the
 * slice 6b fix round): while a dialogue, a shop or a crossing is up the shell
 * passes `waiting` and a press does nothing (`aria-disabled`, dimmed).
 */
import type { Strings } from '@ab/session';
import { text } from './text.ts';
import './ui.css';

export type MenuButtonProps = { readonly strings: Strings; readonly open: boolean; readonly waiting?: boolean; readonly onPress: () => void };

export const MenuButton = ({ strings, open, waiting = false, onPress }: MenuButtonProps) => (
  <button
    type="button"
    className="ab-window ab-menu-button"
    data-testid="menu-button"
    aria-label={text(strings, 'ui.pad.menu')}
    aria-expanded={open}
    aria-disabled={waiting}
    onPointerDown={(e) => {
      e.preventDefault();
      if (!waiting) onPress();
    }}
    onClick={(e) => {
      // A keyboard press (no pointer: `detail` 0); a pointer acted on pointerdown.
      if (e.detail === 0 && !waiting) onPress();
    }}
  />
);
